import {Typography} from "../../../../__snowpack__/pkg/antd.js";
import React from "../../../../__snowpack__/pkg/react.js";
export const Text = (props) => {
  const onChange = (value) => {
    props.onChange?.(value);
    if (typeof props.editable === "object") {
      props.editable?.onChange?.(value ?? "");
    }
  };
  const editable = {
    onChange,
    ...typeof props.editable === "object" ? props.editable : {}
  };
  return React.createElement(Typography.Text, {
    className: "ant-form-text",
    ...props,
    editable: props.editable && editable
  }, props.editable ? String(props.value) : props.value === 0 ? 0 : props.value || "-");
};
